import { render } from "./UserForm.vue?vue&type=template&id=10bd56b6&scoped=true"
import script from "./UserForm.vue?vue&type=script&lang=js"
export * from "./UserForm.vue?vue&type=script&lang=js"

import "./UserForm.vue?vue&type=style&index=0&id=10bd56b6&scoped=true&lang=css"

import exportComponent from "/home/circleci/repo/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bd56b6"]])

export default __exports__